import { render, staticRenderFns } from "./ReportesPage.vue?vue&type=template&id=4d384aac&"
import script from "./ReportesPage.js?vue&type=script&lang=js&"
export * from "./ReportesPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports